import { z } from 'zod'
import { foodSchema, type Food } from './nutrition'

export const booheeCode = z.string().regex(/^[A-Za-z0-9_-]{1,50}$/)
export const booheeRequest = z.discriminatedUnion('type', [
  z.strictObject({ type: z.literal('search'), query: z.string().trim().min(1).max(30), page: z.number().int().min(1).max(20).default(1) }),
  z.strictObject({ type: z.literal('detail'), code: booheeCode }),
])
export type BooheeRequest = z.infer<typeof booheeRequest>
export const booheeSearchResult = z.strictObject({
  foods: z.array(z.strictObject({ code: booheeCode, name: z.string().min(1).max(100), kcal: z.number().finite().min(0).max(10000).optional() })).max(20),
  page: z.number().int().min(1).max(20), hasMore: z.boolean(),
})
export type BooheeSearchResult = z.infer<typeof booheeSearchResult>
export interface ChineseFoodLookup {
  search(query: string, page: number, signal: AbortSignal): Promise<BooheeSearchResult>
  detail(code: string, signal: AbortSignal): Promise<Food>
}
export const booheeDetailResult = z.strictObject({ food: foodSchema.refine(f => f.origin === 'boohee') })
